module.exports = __webpack_public_path__ + "static/img/remixicon.95138f36.95138f36.svg";